import 'assets/styles/compliance.scss';

import React, { useEffect, useState } from 'react';

import SwapHorizontalCircleOutlinedIcon from '@material-ui/icons/SwapHorizontalCircleOutlined';
import { useHistory } from 'react-router-dom';
import { useStore } from "../../hooks";
import { useSnackbar } from "notistack";
import * as config from "../../config/constants";
import AlertDialog from "../../shared/DialogBox/index";

const HorizonScanning = (props) => {
  const [companyRegulationsData, setCompanyRegulationsData] = useState();
  const [companyRegulationsNext, setCompanyRegulationsNext] = useState('');
  const [companyRegulationsCount, setCompanyRegulationsCount] = useState(0);
  const [companyRegulationsDisplayCount, setCompanyRegulationsDisplayCount] = useState(0);
  const [companyRegulationsLoading, setCompanyRegulationsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [downloadedRegulations, setDownloadedRegulations] = useState(new Set());
  const store = useStore();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const numRecordPage = config.pageSize;
  const { customProp } = props;

  // Load downloaded regulations from localStorage on component mount
  useEffect(() => {
    const savedDownloads = localStorage.getItem('downloadedRegulations');
    if (savedDownloads) {
      try {
        const parsedDownloads = JSON.parse(savedDownloads);
        setDownloadedRegulations(new Set(parsedDownloads));
      } catch (error) {
        console.error('Error parsing downloaded regulations from localStorage:', error);
        setDownloadedRegulations(new Set());
      }
    }
  }, []);

  // Save downloaded regulations to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('downloadedRegulations', JSON.stringify([...downloadedRegulations]));
  }, [downloadedRegulations]);

  const getCompanyRegulations = async () => {
    try {
      setIsLoading(true);
      const { data } = await store.api.getCompanyRegulations();
      setCompanyRegulationsData(data.results || data);
      setCompanyRegulationsNext(data.next);
      setCompanyRegulationsCount(data.count || (data.results ? data.results.length : data.length));
      const count = data.count || (data.results ? data.results.length : data.length);
      count > numRecordPage
        ? setCompanyRegulationsDisplayCount(numRecordPage)
        : setCompanyRegulationsDisplayCount(count);
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getNextCompanyRegulations = async () => {
    try {
      setCompanyRegulationsLoading(true);
      const { data } = await store.api.getNextDataWithURL(companyRegulationsNext);
      setCompanyRegulationsData(data.results || data);
      setCompanyRegulationsNext(data.next);
    } catch (error) {
      setCompanyRegulationsLoading(false);
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setCompanyRegulationsLoading(false);
    }
  };

  useEffect(() => {
    getCompanyRegulations();
  }, []);

  const navigateToRegulation = (regulationId) => {
    const path = '/micro-regulatory-list?regulation=' + regulationId;
    history.push(path);
  };

  const handleDownload = (regulationId, event) => {
    event.stopPropagation(); // Prevent row click when button is clicked
    setDownloadedRegulations(prev => new Set([...prev, regulationId]));
    // Here you can add actual download logic if needed
    enqueueSnackbar('Download started for regulation ' + regulationId, {
      variant: 'success',
    });
  };

  return (
    <section className={'compliance-container'}>
      <div className="back-nav" onClick={() => history.push('/companies-dashboard')}>
        Home
      </div>
      <SwapHorizontalCircleOutlinedIcon
        style={{
          width: '42px',
          height: '42px',
          color: '#e0123c',
          fontSize: 'large',
          position: 'absolute',
        }}
      />
      <h4>Horizon Scanning</h4>

      <ul className="categories-list">
        <li key="count" style={{ backgroundColor: '#f4f5f7' }}>
          <div>This screen lists all Regulatory Documents that have been flagged as applicable to this firm type (e.g. UK MIFID Firm).&nbsp;</div>
          <div><strong>ACTION</strong>: It is the responsibility of the system owner to mark each Regulatory Document as APPLICABLE to their organisation, or NOT APPLICABLE, adding appropriate reasons for Audit Trail purposes.&nbsp;</div>
          <div><strong>RESULT</strong>: Applicable Regulatory Documents will be converted into Regulatory Micro-processes and sent to the Impact Assessment Screen for Assignment to process owners, validation as applicable.</div>
        </li>

        {isLoading && (
          <li key="loading" style={{ textAlign: 'center', padding: '20px' }}>
            Loading regulations...
          </li>
        )}

        {!isLoading && companyRegulationsData !== undefined &&
          companyRegulationsData.map((regulation, i) => {
            const regulationId = regulation.id;
            const isDownloaded = downloadedRegulations.has(regulationId);
            return (
              <li key={i} >
                <span>{regulationId}</span>
                <span className="title-spacing">{regulation.name}</span>
                <div className="status-text">
                  <span className="last-updated">
                    Effective Date: {regulation.effective_date}
                  </span>
                </div>
                 <span
                  className={`applicable-status ${'Applicable'}`}
                >
                   APLICABLE
                 <AlertDialog
                  reason={regulation.summary}
                  name={regulation.name}
                  applicable={regulation.name}
                  title="Why is this regulation applicable to our organization?"
                />
                </span>
                <button
                  onClick={(e) => handleDownload(regulationId, e)}
                  style={{
                    backgroundColor: isDownloaded ? '#4caf50' : '#f44336',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s ease',
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)'
                  }}
                >
                  Download
                </button>
              </li>
            );
          })}
        {companyRegulationsCount > numRecordPage && (
          <li className="get-next" key="next" onClick={() => getNextCompanyRegulations()}>
            <span>{companyRegulationsLoading ? 'Loading...' : 'Load ' + numRecordPage.toString() + ' more'}</span>
          </li>
        )}
      </ul>
    </section>
  );
};

HorizonScanning.defaultProps = {};

export default HorizonScanning;
